import React from 'react';
import { motion } from 'framer-motion';
export const PageTransition = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -15
  }} transition={{
    duration: 0.3,
    ease: 'easeOut'
  }} className={`flex-1 flex flex-col ${className}`} data-id="element-46">
      {children}
    </motion.div>;
};